var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.857.857h14.286v14.286H.857z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51 6.26H6.02c-.32 0-.583.271-.583.601v7.205c0 .33.262.6.582.6H9.51c.32 0 .582-.27.582-.6V6.861c0-.33-.262-.6-.582-.6zM7.765 9.864c-.64 0-1.164-.54-1.164-1.2 0-.66.524-1.201 1.164-1.201.64 0 1.163.54 1.163 1.2 0 .661-.523 1.201-1.163 1.201zM4.885 4.49l.82.846a2.877 2.877 0 0 1 2.06-.876c.803 0 1.53.336 2.06.876l.82-.846a3.997 3.997 0 0 0-2.88-1.231 3.997 3.997 0 0 0-2.88 1.23zM7.765.857A6.283 6.283 0 0 0 3.238 2.79l.82.847a5.163 5.163 0 0 1 3.707-1.579 5.12 5.12 0 0 1 3.7 1.585l.82-.847A6.241 6.241 0 0 0 7.766.857z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.4e80aaef08538276b894bb01cb5699f7.svg";
export { ForwardRef as ReactComponent };